up.compiler('[training-grounds-search]', (element) => {

  const map = element.querySelector('[training-grounds-search--map]')
  const list = element.querySelector('[training-grounds-search--list]')
  const form = element.querySelector('.training-grounds--search form')

  if (!map) throw 'Could not find map'
  if (!list) throw 'Could not find list'
  if (!form) throw 'Could not find form'

  function init() {
    map.addEventListener('app:map:pinClicked', onMapPinClicked)
    list.addEventListener('click', onListRowClicked)
    form.addEventListener('up:form:submit', onMapDataChanged)
    form.addEventListener('keyup', onEnterPressed)
    up.on(element, 'app:map:placeChanged', onMapDataChanged)
  }

  function onMapPinClicked(event) {
    const pinData = event.pinData
    highlightRow(pinData.id)
  }

  function onListRowClicked(event) {
    const row = event.target.closest('.training-grounds--training-ground')
    if (row) {
      const id = parseInt(row.getAttribute('data-training-ground-id'))
      const url = row.getAttribute('data-training-ground-url')
      highlightRow(id)
      up.emit(map, 'app:map:focusPin', { pinId: id })
      up.emit(map, 'app:map:rowClicked', { pinData: { url: url } })
    }
  }

  function highlightRow(id) {
    list.querySelectorAll('.training-grounds--training-ground.-highlighted').forEach((element) => { element.classList.remove('-highlighted') })
    list.querySelectorAll(`.training-grounds--training-ground[data-training-ground-id="${id}"]`).forEach((element) => { element.classList.add('-highlighted') })
  }

  function onMapDataChanged(event) {
    const url = form.action
    const params = up.Params.fromForm(form)
    const headers = { 'Content-Type': 'application/json', 'Accept': 'application/json'}

    up.request(url, { params: params, headers: headers, solo: false }).then((response) => {
      let mapData = JSON.parse(response.text)

      up.emit(map, 'app:map:dataChanged', { mapData: mapData })
    })
    up.navigate('[training-grounds-search--results]', { url, params: params, solo: false })

    event.preventDefault()
  }

  function onEnterPressed(event) {
    event.preventDefault()
    event.stopImmediatePropagation()
  }

  init()

})
